import React from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Footer from './components/organisms/Footer';
import Header from './components/organisms/Header';
import SocialAside from './components/organisms/SocialAside';
import { FirebaseAppProvider } from 'reactfire';
import Category from "./components/pages/Category";
import Home from "./components/pages/Home";
import Product from "./components/pages/Product";
import SubCategory from "./components/pages/SubCategory";
import { firebaseConfig } from './firebaseConfig';
import Entrega from './components/organisms/Entrega';

function App() {
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <Router>
      <Header />
      <SocialAside />
      <Switch>
        <Route path='/' exact component={Home}/>
        <Route path='/categorias' exact component={Home}/>
        <Route path='/categorias/:category' exact component={Category}/>
        <Route path='/categorias/:category/:subCategory' exact component={SubCategory}/>
        <Route path='/categorias/:category/:subCategory/:product' exact component={Product}/>
      </Switch>
      <Entrega />
      <Footer />
    </Router>
    </FirebaseAppProvider>
  );
}

export default App;
